import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FirestoreService } from 'src/app/services/firestore.service';
import { PreloadImgService } from 'src/app/services/preload-img.service';

interface Item {
  name: string;
  hombres?: string;
  mujeres?: string;
  visible?: boolean;
}

@Component({
  selector: 'app-estilo',
  templateUrl: './estilo.component.html',
  styleUrls: ['./estilo.component.scss'],
})
export class EstiloComponent implements OnInit, OnDestroy {

  genero!: string;

  styles: Item[] = [];
  designCollection: Item[] = [];

  imgDefault = this.preloadImg.defaultImg;

  private destroy$ = new Subject<void>();

  constructor(
    private preloadImg: PreloadImgService,
    private router: Router,
    private route: ActivatedRoute,
    private firestore: FirestoreService
  ) {}

  ngOnInit() {
    this.genero = this.route.snapshot.params['genero'];
    this.loadData();
  }

  // 🔥 Carga unificada
  loadData() {
    const styles$ = this.firestore.getCollection<Item>('styles');
    const design$ = this.firestore.getCollection<Item>('designCollection');

    combineLatest([styles$, design$])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([styles, design]) => {

        this.styles = this.filterByGenero(styles, true);
        this.designCollection = this.filterByGenero(design);
      });
  }

  // 🧠 lógica reutilizable
  private filterByGenero(data: Item[], checkVisible = false): Item[] {
    return data.filter(item => {
      const hasGenero = item.hasOwnProperty(this.genero);
      const isVisible = checkVisible ? item.visible : true;
      return hasGenero && isVisible;
    });
  }

  // 🎯 navegación
  goDesignGarment() {
    this.router.navigate([`catalog3d/estilo/${this.genero}`]);
  }

  navigate(item: Item) {
    this.router.navigate([`/search/${this.genero}/${item.name}`]);
  }

  // 🧹 limpieza
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // 🎨 helper UI
  isOdd(length: number): boolean {
    return length % 2 !== 0;
  }

  // 🖼️ helper imagen (elimina *ngIf duplicados)
  getImage(item: Item): string {
    return this.genero === 'hombres' ? item.hombres! : item.mujeres!;
  }
}
